<input class="input"
        type="text"
        [(ngModel)]="autocompleteInput"
        class="form-control"
        #addresstext
        >
